import { FlexCell } from '@epam/promo';

import { StatisticsCardHeader } from 'components/common';
import { StatisticsTask } from '../StatisticsTask/StatisticsTask';
import { StatisticsNoData } from '../StatisticsNoData';
import { StatisticsTasksProps } from './StatisticsTasks.model';
import css from './StatisticsTasks.module.scss';

export const StatisticsTasks = ({
  title,
  range,
  tooltip,
  tasks = [],
  isFailed,
  isLoading,
  onTaskClick,
}: StatisticsTasksProps) => (
  <FlexCell
    cx={{
      [css['statistics-tasks__wrapper']]: true,
      'skeleton-loader': isLoading,
    }}>
    <StatisticsCardHeader range={range} title={title} tooltip={tooltip} />
    <FlexCell cx={css['statistics-tasks__container']}>
      {tasks.length && (
        <>
          <div className={css['statistics-tasks__scroll']}>
            {tasks.map(({ id, ...statisticsTaskProps }) => (
              <StatisticsTask
                key={id}
                isFailed={isFailed}
                onTaskClick={() => onTaskClick(id ?? '')}
                {...statisticsTaskProps}
              />
            ))}
          </div>
          <div className={css['statistics-tasks__gradient']} />
        </>
      )}
      {!tasks.length && <StatisticsNoData />}
    </FlexCell>
  </FlexCell>
);
